/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientWorkspaceUserDto } from '../../models/client-workspace-user-dto';

export interface ClientWorkspaceUserControllerWithdraw$Params {

/**
 * 고객사 ID
 */
  id: string;
}

export function clientWorkspaceUserControllerWithdraw(http: HttpClient, rootUrl: string, params: ClientWorkspaceUserControllerWithdraw$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientWorkspaceUserDto>> {
  const rb = new RequestBuilder(rootUrl, clientWorkspaceUserControllerWithdraw.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientWorkspaceUserDto>;
    })
  );
}

clientWorkspaceUserControllerWithdraw.PATH = '/api/clientWorkspaceUser/{id}/withdraw';
